import Cookies from 'cookies-ts';

const cookies = new Cookies();

export default cookies;
